<template>
  <div class="left-part h-100 bg-light d-flex justify-content-center align-items-center">
    <div class="auth-image-block">
      <div class="auth__logoimg">
        <img :src="`/images/general/${isDocPro() ? 'logo_medical.png' : 'logo.png'}`" alt="logo"/>
      </div>
      <div class="auth__slogan">{{ isDocPro() ? $t('general_slogan') : $t('slogan') }}</div>
      <div class="auth__logochair">
        <img :src="`/images/login/${ isDocPro() ? 'medical_seat.webp' : 'seat.webp'}`" class="img" alt="logo"/>
      </div>
    </div>
  </div>
</template>

<script setup>
import {isDocPro} from "@/services/auth.helper"
</script>
